// 风电场模块
import WindFarm from '@/views/wind-farm/index';
export default [
  {
    name: 'root',
    path: '/wind-farm',
    redirect: '/wind-farm/project-list',
    components: {
      Home: WindFarm
    },
    children: [
      {
        name: 'project-detail',
        path: 'project-detail',
        components: {
          content: () => import('@/views/wind-farm/project-detail')
        },
        children: [
          {
            name: 'resource',
            path: 'resource',
            components: {
              Modal: () => import('@/views/wind-farm/project-detail/resource')
            }
          },
          {
            name: 'deploy',
            path: 'deploy',
            components: {
              Modal: () => import('@/views/wind-farm/project-detail/deploy')
            }
          },
          {
            name: 'road',
            path: 'road',
            components: {
              Modal: () => import('@/views/wind-farm/project-detail/road')
            }
          },
          {
            name: 'line',
            path: 'line',
            components: {
              Modal: () => import('@/views/wind-farm/project-detail/line')
            }
          },
          {
            name: 'power',
            path: 'power',
            components: {
              Modal: () => import('@/views/wind-farm/project-detail/power')
            }
          },
          {
            name: 'finance',
            path: 'finance',
            components: {
              Modal: () => import('@/views/wind-farm/finance')
            },
            children: [
              {
                name: 'estimate',
                path: 'estimate',
                components: {
                  content: () => import('@/views/wind-farm/finance/estimate')
                }
              },
              {
                name: 'economic',
                path: 'economic',
                components: {
                  content: () => import('@/views/wind-farm/finance/economic')
                }
              }
            ]
          }
        ]
      },
      {
        name: 'project-list',
        path: 'project-list',
        components: {
          content: () => import('@/views/wind-farm/sidebar')
        }
      }
    ]
  }
];
